import React, { useState } from "react"

//Referal modules
import MapSearch from "./MapSearch"
import ReferralEntityForm from "../EntityProfile/Form/ReferralEntityForm"
import { findServiceCategoryByKey } from "../sharedFunctions"
import CategorySelection from "./CategorySelection"
import { Dialog } from "primereact/dialog"

export default function ReferralEntitySearch({
  address,
  defaultCategory,
  isPopup,
  onEntitySelect,
}) {
  const [doMapSearch, setDoMapSearch] = useState(true)
  const [referralLocations, setReferralLocations] = useState([])
  const [referralMapLocations, setReferralMapLocations] = useState([])
  const [refCategories, setRefCategories] = useState(undefined)
  const [cachedMap, setCachedMap] = useState()
  const [selectedLocation, setSelectedLocation] = useState(undefined)

  const onSearchOptionChanged = () => {
    setDoMapSearch(!doMapSearch)
  }

  function onSelection(entityLocation) {
    onEntitySelect(entityLocation)
  }

  function onCreation(entity) {
    let selectedLocation = entity
    if (!!selectedLocation.referralEntity) {
      selectedLocation = {
        address: entity.referralLocation.location.address,
        city: entity.referralLocation.location.city,
        country: entity.referralLocation.location.country,
        email: entity.referralLocation.location.email,
        entityId: entity.referralEntity.id,
        locationId: entity.referralLocation.location.id,
        entityName: entity.referralEntity.name,
        name: entity.referralLocation.location.name,
        phone: entity.referralLocation.location.phone,
        state: entity.referralLocation.location.state,
        virtual: entity.referralLocation.location.virtual,
        website: entity.referralLocation.location.website,
        zipcode: entity.referralLocation.location.zipcode,
      }

      //Set category descriptions
      const categoryIds = entity.referralLocation.serviceTypes
        .map((type) => {
          const category = findServiceCategoryByKey(type.id, refCategories)
          if (!category.children) {
            return category.label
          } else {
            return ""
          }
        })
        .filter((category) => category !== "")

      selectedLocation.referralCategories = categoryIds
    }

    setSelectedLocation(selectedLocation)
  }

  return (
    <>
      {!!selectedLocation ? (
        <Dialog
          header={`Select the service category for this referral to ${selectedLocation.entityName}`}
          style={{ width: "500px", height: "700px" }}
          visible={!!selectedLocation}
          onHide={() => setSelectedLocation(undefined)}
        >
          <CategorySelection
            selectedLocation={selectedLocation}
            onCancelSelection={() => {
              setSelectedLocation(undefined)
            }}
            onSubmitSelection={(selectedLocation) => {
              onSelection(selectedLocation)
              setSelectedLocation(undefined)
            }}
          />
        </Dialog>
      ) : null}
      {doMapSearch ? (
        <MapSearch
          initialLong={0}
          initialLat={0}
          address={address}
          filterCategory={defaultCategory}
          referralLocations={referralLocations}
          referralMapLocations={referralMapLocations}
          referralCategories={refCategories}
          mapSearch={doMapSearch}
          cachedMap={cachedMap}
          onSetReferralLocations={(refs) => {
            setReferralLocations(refs)
          }}
          onSetReferralMapLocations={(refs) => {
            setReferralMapLocations(refs)
          }}
          onSetReferralCategories={(cats) => {
            setRefCategories(cats)
          }}
          onSetMapCache={(map) => {
            setCachedMap(map)
          }}
          onEntitySelectedCallBack={setSelectedLocation}
          onSearchOptionChangeCallBack={onSearchOptionChanged}
          isPopup={isPopup}
        />
      ) : (
        <ReferralEntityForm
          onCancelClick={onSearchOptionChanged}
          onEntityCreated={onCreation}
          isPopup={isPopup}
        />
      )}
    </>
  )
}
